"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('command', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: props.strokeLinejoin
  }, _react.default.createElement("g", {
    transform: "translate(4.000000, 4.000000)",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth
  }, _react.default.createElement("path", {
    d: "M5.45454545,10.9090909 C6.50229041,10.9090909 8.32047227,10.9090909 10.9090909,10.9090909 C10.9090909,8.23329045 10.9090909,6.41510868 10.9090909,5.45454545 C10.9090909,2.44208318 8.46700773,0 5.45454545,0 C2.44208318,0 0,2.44208318 0,5.45454545 C0,8.46700773 2.44208318,10.9090909 5.45454545,10.9090909 Z",
    fill: props.outFillColor,
    fillRule: "nonzero"
  }), _react.default.createElement("path", {
    d: "M5.45454545,29.0909091 L10.9090909,29.0909091 L10.9090909,34.5454545 C10.9090909,37.5579168 8.46700773,40 5.45454545,40 C2.44208318,40 0,37.5579168 0,34.5454545 C0,31.5329923 2.44208318,29.0909091 5.45454545,29.0909091 Z",
    fill: props.outFillColor,
    fillRule: "nonzero"
  }), _react.default.createElement("rect", {
    strokeLinecap: props.strokeLinecap,
    x: "10.9090909",
    y: "10.9090909",
    width: "18.1818182",
    height: "18.1818182"
  }), _react.default.createElement("path", {
    d: "M34.5454545,10.9090909 L29.0909091,10.9090909 L29.0909091,5.45454545 C29.0909091,2.44208318 31.5329923,0 34.5454545,0 C37.5579168,0 40,2.44208318 40,5.45454545 C40,8.46700773 37.5579168,10.9090909 34.5454545,10.9090909 Z",
    fill: props.outFillColor,
    fillRule: "nonzero"
  }), _react.default.createElement("path", {
    d: "M34.5454545,29.0909091 C37.5579168,29.0909091 40,31.5329923 40,34.5454545 C40,37.5579168 37.5579168,40 34.5454545,40 C31.5329923,40 29.0909091,37.5579168 29.0909091,34.5454545 L29.0909091,29.0909091 L34.5454545,29.0909091 Z",
    fill: props.outFillColor,
    fillRule: "nonzero"
  }))));
});

exports.default = _default;